import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  small: css``,
  medium: css``,
  large: css``,
  interactive: css``,
};

export const thumbnail = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 4px;
  border: ${theme.colors.primary['20']};
  border-radius: 2px;

  &.${variants.small} {
    width: 60px;
    height: 60px;
  }

  &.${variants.medium} {
    width: 100px;
    height: 100px;
  }

  &.${variants.large} {
    width: 160px;
    height: 160px;
  }

  &.${variants.interactive} {
    &:hover {
      cursor: pointer;
    }
  }

  border-width: 0;
`;
